module.exports = __webpack_public_path__ + "img/help-circle-outline.5fc0ff8b.svg";